import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Services = lazy(() => import('../pages/services/page'));
const Gallery = lazy(() => import('../pages/gallery/page'));
const Blog = lazy(() => import('../pages/blog/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Blog Posts
const SpringCleaningChecklist = lazy(() => import('../pages/blog/posts/spring-cleaning-checklist'));
const EcoFriendlyCleaningTips = lazy(() => import('../pages/blog/posts/eco-friendly-cleaning-tips'));
const MoveOutCleaningGuide = lazy(() => import('../pages/blog/posts/move-out-cleaning-guide'));
const HowOftenDeepClean = lazy(() => import('../pages/blog/posts/how-often-deep-clean'));
const OfficeCleaningProductivity = lazy(() => import('../pages/blog/posts/office-cleaning-productivity'));
const PostConstructionCleaning = lazy(() => import('../pages/blog/posts/post-construction-cleaning'));
const KitchenDeepCleaning = lazy(() => import('../pages/blog/posts/kitchen-deep-cleaning'));
const BathroomCleaningHacks = lazy(() => import('../pages/blog/posts/bathroom-cleaning-hacks'));
const IndoorAirQuality = lazy(() => import('../pages/blog/posts/indoor-air-quality'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/services',
    element: <Services />,
  },
  {
    path: '/gallery',
    element: <Gallery />,
  },
  {
    path: '/blog',
    element: <Blog />,
  },
  {
    path: '/blog/spring-cleaning-checklist',
    element: <SpringCleaningChecklist />,
  },
  {
    path: '/blog/eco-friendly-cleaning-tips',
    element: <EcoFriendlyCleaningTips />,
  },
  {
    path: '/blog/move-out-cleaning-guide',
    element: <MoveOutCleaningGuide />,
  },
  {
    path: '/blog/how-often-deep-clean',
    element: <HowOftenDeepClean />,
  },
  {
    path: '/blog/office-cleaning-productivity',
    element: <OfficeCleaningProductivity />,
  },
  {
    path: '/blog/post-construction-cleaning',
    element: <PostConstructionCleaning />,
  },
  {
    path: '/blog/kitchen-deep-cleaning',
    element: <KitchenDeepCleaning />,
  },
  {
    path: '/blog/bathroom-cleaning-hacks',
    element: <BathroomCleaningHacks />,
  },
  {
    path: '/blog/indoor-air-quality',
    element: <IndoorAirQuality />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;